import { useLocation } from 'react-router-dom';
import { PageHeader } from './PageHeader';

// Shown for menu items whose page hasn't been migrated to React yet, so the
// sidebar stays complete (matching legacy) and links resolve inside the shell.
export function NotMigratedPage() {
  const { pathname } = useLocation();
  return (
    <div>
      <PageHeader title="Coming to the new UI" breadcrumb={['Home', pathname]} />
      <div className="card">
        <div className="card-body text-center py-5">
          <i className="ri-tools-line text-muted" style={{ fontSize: '2.5rem' }} />
          <h5 className="mt-3">This page hasn't been migrated yet</h5>
          <p className="text-muted mb-1">
            <code>{pathname}</code>
          </p>
          <p className="text-muted">It's still served by the current application and will be migrated to React.</p>
        </div>
      </div>
    </div>
  );
}
